<template>
  <div class="main-con el-main">
    <nav-breadcrumb :menu="[{label: '逾期贷款报表'}]"/>
    <el-row class="xzpadd10 bg-purple">
      <data-table
        :tableData="listData"
        :columns="listColumns"
        :pageSize.sync="pageSize"
        :page.sync="page"
        :filters="filters"
        :actions="actions"
      ></data-table>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "FangReportingOverdueList",
      data() {
        return {
          transactionStatus: this.$route.query['fi.transactionStatus'],
          page: 1,
          pageSize: 20,
          listData: {},
          listColumns: [
            {
              name: '序号',
              type: 'index'
            },
            {
              name: '贷款编号',
              field: 'fi__transactionNo'
            },
            {
              name: '客户姓名',
              field: 'c__customerName'
            },
              {
                  name: '渠道商',
                  field: 'd__dealerName'
              },
           /* {
              name: '客户手机号',
              field: 'c__customerContactNo'
            },*/

            {
              name: '还款期数',
              field: 'plan__sequenceNo'
            },
            {
              name: '应还款日',
              field: 'plan__repayDate',
              formatter: function (r,c,v) {
                if(v)
                  return moment(v).format('YYYY-MM-DD')
              }
            },

           /* {
              name: '贷款余额',
              field: 'plan__principalAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },*/

            {
              name: '应收本金(元)',
              field: 'plan__principalAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },

            {
              name: '应收利息(元)',
              field: 'plan__interestAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              name: '本息合计(元)',
              field: 'plan__repayAmount',
              formatter: function (r,c,v) {
                return formatMoney(parseFloat(r.plan__interestAmount)+parseFloat(r.plan__principalAmount))
              }
            },

          /*  {
              name: '逾期天数',
              field: 'bal__overdueDays'
            },
            {
              name: '预计逾期罚息',
              field: 'bal__overdueFine',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            }*/
          ],
          filters: {
            form: {
              fi__endDate: [],
              fi__transactionNo:'',
              c__customerName:'',
              c__customerContactNo:'',
                d__dealerId:'',
            },
            columns: [
                {
                    label: '渠道商',
                    component: 'el-select',
                    field: 'd__dealerId',
                    options:[],
                    span: 12
                },
              {
                label: '贷款编号',
                component: 'el-input',
                field: 'fi__transactionNo',
              },
              {
                label: '客户姓名',
                component: 'el-input',
                field: 'c__customerName',
              },
              /*{
                label: '客户手机号',
                component: 'el-input',
                field: 'c__customerContactNo',
              },*/
              {
                label: '应还款日',
                component: 'date-range-picker',
                field: 'plan__repayDate',
              },
            ],
            onSubmit:()=>{
              this.page = 1
              this.getReportingOverdueList()
            }
          },
          actions: [
            {
              label: '导出',
              clickHandler:()=>{
                let routeData = this.$router.resolve({
                  path: '/ix/fang/financing/reporting/Overdue.List?format=xlsx',
                  query: Object.assign({}, this.filterParams, xmlBuildQuery(this.filters))
                });
                window.open(routeData.href.replace('#/', '/'), '_blank');
              }
            }
          ],
        }
      },
      computed : {
        filterParams: {
          get: function() {
            return {
              pageSize: this.pageSize,
              pageOffset: (this.page - 1) * this.pageSize,
              // 'xlist.sort.dataField': 'fi.transactionDate',
              // 'xlist.sort.order': 'desc'
            }
          },
          set:function (newVal) {

          }
        }
      },
      watch: {
        filterParams: function () {
          this.getReportingOverdueList()
        }
      },
      mounted() {
        this.getReportingOverdueList()
          this.getDealerList()
      },
      methods: {
          getDealerList: function () {
              xhr.getDealerList(
                  Object.assign({pageSize: 0}, {}, {}),
                  res => {
                      try {
                          /*this.filters.columns[0].options = [
                            {
                              label: '所有渠道商',
                              value: ''
                            }
                          ].concat(res.data.data.map(item=>{
                            return {
                              label: item.d__dealerName,
                              value:item.d__dealerId,
                            }
                          }))*/
                          this.filters.columns[0].options = res.data.data.map(item => {
                              return {
                                  label: item.d__dealerName,
                                  value: item.d__dealerId,
                              }
                          })
                      } catch (e) {

                      }
                  })
          },
        getReportingOverdueList: function () {
          xhr.getFangReportingOverdueList(
            Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
            res=> {
              try {
                this.listData = res.data
              }catch(e){

              }
            })

        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/FangReportingOverdueList.vue